export class ChartValue {
    public label: string;
    public data: any[];
    public identifier: any;
    public lastItemIdentifier: any;

    constructor(_label: string = '', _data: any[] = [], _identifier: any = null) {
        this.label = _label;
        this.data = _data;
        this.identifier = _identifier;
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/chart/chart-value.model.ts